const list = {
    or: 'یا',
    and: 'و',
    separator: '،',
};
export default Object.freeze(list);
